import { motion } from "framer-motion";
import { aboutData, siteConfig } from "../data/mock";

const AboutPage = () => {
  return (
    <div className="bg-white min-h-screen pt-32 pb-24 md:pb-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-20 md:mb-28"
        >
          <h1 className="font-serif text-[32px] md:text-[42px] text-[#1a1a1a] tracking-[-0.02em]">
            About
          </h1>
        </motion.div>

        {/* Layout Grid: Left column (Photo + Laurels) vs Right column (Bio text) */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 mb-24 md:mb-32">
          
          {/* Left Column - Reduced size (lg:col-span-4) for smaller photo & laurels alignment */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="lg:col-span-4"
          >
            {/* 1. Portrait Photo */}
            <div className="aspect-[3/4] overflow-hidden bg-[#f5f4f2] mb-12">
              <img
                src={aboutData.portrait}
                alt={`${siteConfig.director} portrait`}
                className="w-full h-full object-cover grayscale"
                loading="lazy"
              />
            </div>

            {/* 2. Selected Recognition directly underneath photo */}
            <div className="mt-10">
              {/* Your New Line Block */}
<p className="font-serif text-[24px] md:text-[28px] text-[#1a1a1a] mb-6">
  Sumo Didi
</p>
              <div style={{ textAlign: 'left', width: '100%' }}>
                <img
                  src="/laurels_updated 2.png"
                  alt="Film Festival Laurels"
                  style={{
                    display: 'block',
                    width: '100%',
                    maxWidth: '420px', 
                    height: 'auto'
                  }}
                />
              </div>
            </div>
          </motion.div>

          {/* Right Column - Bio Text (lg:col-span-8) */}
          <div className="lg:col-span-8 lg:pt-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <p className="text-[11px] tracking-[0.2em] uppercase text-[#bbb] mb-6">
                Filmmaker
              </p>
              <p className="font-serif text-[22px] md:text-[26px] text-[#1a1a1a] leading-[1.5] tracking-[-0.01em] mb-8">
                {siteConfig.director}
              </p>
              <p className="text-[15px] text-[#4a4a4a] leading-[1.9] tracking-[0.01em] max-w-[540px] text-justify">
                {aboutData.bio}
              </p>
            </motion.div>
          </div>

        </div>

        {/* Sections: How I Work, What I am Exploring, etc. */}
        <div className="max-w-[720px] mt-24 md:mt-32">
          {aboutData.sections.map((section, i) => (
            <motion.div
              key={section.heading}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.8,
                delay: 0.1,
                ease: [0.4, 0, 0.2, 1],
              }}
              className={i > 0 ? "mt-16 md:mt-20 pt-10 md:pt-14 border-t border-[#f0eeeb]" : ""}
            >
              <h2 className="font-serif text-[22px] md:text-[26px] text-[#1a1a1a] tracking-[-0.01em] mb-6">
                {section.heading}
              </h2>
              <p className="text-[15px] text-[#4a4a4a] leading-[1.9] tracking-[0.01em] whitespace-pre-line text-justify">
                {section.text}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default AboutPage;
